import instantsearch from 'instantsearch.js';
import {
    clearRefinements,
    configure,
    currentRefinements,
    hits,
    pagination,
    refinementList,
    toggleRefinement,
} from 'instantsearch.js/es/widgets';

import { getAlgoliaSearchClient, normalizeFilterItems, normalizeRefinements } from './algolia-helpers';
import { textilesRouting } from './textiles-routing';

if (document.getElementById('textiles-hits')) {
    
    function sortDura(a,b) {
        return Number(a.name.match(/[0-9]+/)[0]) - Number(b.name.match(/[0-9]+/)[0]);
    }
    
    const searchClient = getAlgoliaSearchClient();
    const indexName = `${window.algolia.prefix}_mckinnon_textiles`;
    const search = instantsearch({
        indexName,
        searchClient,
        searchParameters: {
            disjunctiveFacetsRefinements: {
                type: ['Textiles Variant'],
            },
            filters: 'status:live OR status:enabled',
            hitsPerPage: 36,
        },
        routing: textilesRouting,
        searchFunction(helper) {
            const page = helper.getPage();
            const { disjunctiveFacetsRefinements } = helper.state;

            if (disjunctiveFacetsRefinements.new) {
                helper.setIndex(`${window.algolia.prefix}_mckinnon_textiles_new`);
            } else if (disjunctiveFacetsRefinements.yard) {
                helper.setIndex(`${window.algolia.prefix}_mckinnon_textiles_yard`);
            } else if (disjunctiveFacetsRefinements.collection || disjunctiveFacetsRefinements.categories || disjunctiveFacetsRefinements.color || disjunctiveFacetsRefinements.featured || disjunctiveFacetsRefinements.styles || disjunctiveFacetsRefinements.durability || disjunctiveFacetsRefinements.price_tier) {
                helper.setIndex(`${window.algolia.prefix}_mckinnon_textiles_filtered`);
            } else {
                helper.setIndex(`${window.algolia.prefix}_mckinnon_textiles`);
            }

            if (helper.state.disjunctiveFacetsRefinements) {
                helper.state.disjunctiveFacetsRefinements = normalizeRefinements(
                    helper.state.disjunctiveFacetsRefinements
                );
            }

            helper.setPage(page);
            helper.search();
        },
    });

    search.addWidgets([
        configure({
            analytics: true,
            clickAnalytics: true,
        }),

        clearRefinements({
            container: '#clear-refinements',
            excludedAttributes: ['type'],
            templates: {
                resetLabel: 'Clear Filters',
            },
            cssClasses: {
                button: ['button', 'clear-filters'],
                disabledButton: ['hidden-button'],
            },
        }),

        clearRefinements({
            container: '#clear-refinements-second',
            excludedAttributes: ['type'],
            templates: {
                resetLabel: 'Clear Filters',
            },
            cssClasses: {
                button: ['clear-filters', 'js-clear-filters'],
                disabledButton: ['hidden-button'],
            },
        }),

        currentRefinements({
            container: '#current-refined-values',
            excludedAttributes: ['type'],
            transformItems(items) {
                return items.map(item => ({
                    ...item,
                    refinements: item.refinements.map(function(refinement) {
                        switch (refinement.attribute) {
                            case 'new':
                                refinement.label = 'New';
                                break;
                            case 'yard':
                                refinement.label = 'Available by the Yard';
                                break;
                            default:
                        }

                        return refinement;
                    }),
                }));
            },
        }),

        hits({
            container: '#textiles-hits',
            transformItems(items) {
                return items.map(hit => ({
                    ...hit,
                    coordinatingFinishesDisplay:
                        Array.isArray(hit.coordinatingFinishes) && hit.coordinatingFinishes.length
                            ? hit.coordinatingFinishes.join(', ')
                            : null,
                }));
            },
            templates: {
                item: `
    				<div
                        class="alg-swatch"
                        onclick="if (!window.internalIPs.includes(window.userIP)) window.aa('clickedObjectIDsAfterSearch', {
                            index: '${indexName}',
                            eventName: 'Search Result Clicked',
                            objectIDs: ['{{ objectID }}'],
                            queryID: '{{ __queryID }}',
                            positions: [{{ __position }}],
                        });"
                    >
					    <a href="{{ uri }}">
					        <figure>
					            <img 
					                src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" 
					                src="{{ image1x }}" 
					                srcset="
					                    {{ image1x }} 1x,
					                    {{ image2x }} 2x
					                "
					                alt=""
					            />
					        </figure>
					        <h3>
                                {{ product_title }}
                                <br><span>{{ title }} {{ sku }}</span>
                                {{#coordinatingFinishesDisplay}}
                                    <br><span class="cfinish">Coordinates with {{ coordinatingFinishesDisplay }}</span>
                                {{/coordinatingFinishesDisplay}}
                            </h3>
					    </a>
					</div><!-- /.alg-swatch -->
    			`,
                empty: 'Sorry, your search returned no results.',
            },
        }),

        pagination({
            container: '#pagination',
            scrollTo: document.getElementById('textiles-filters'),
        }),

        refinementList({
            container: '#facet-collection',
            attribute: 'collection',
            limit: 100,
            templates: {
                item: `
                <div class="facet-item">
                    <a href="" class="facet-link toggle-refine facet-disjunctive">
                        <label>{{ label }}</label>
                    </a>
                </div><!-- /.facet-item -->
            `,
            },
            transformItems(items) {
                return normalizeFilterItems(items);
            },
        }),
        
        /*refinementList({
            container: '#facet-categories',
            attribute: 'categories',
            limit: 100,
            templates: {
                item: `
                <div class="facet-item">
                    <a href="" class="facet-link toggle-refine facet-disjunctive">
                        <label>{{ label }}</label>
                    </a>
                </div><!-- /.facet-item -->
            `,
            },
            transformItems(items) {
                return normalizeFilterItems(items);
            },
        }),*/

        refinementList({
            container: '#facet-color',
            attribute: 'color',
            limit: 100,
            sortBy: ['name:asc'],
            templates: {
                item: `
                <div class="facet-item">
                    <a href="" class="facet-link toggle-refine facet-disjunctive">
                        <label>{{ label }}</label>
                    </a>
                </div><!-- /.facet-item -->
            `,
            },
            transformItems(items) {
                return normalizeFilterItems(items);
            },
        }),
        
        refinementList({
            container: '#facet-featured',
            attribute: 'featured',
            limit: 100,
            sortBy: ['name:asc'],            
            templates: {
                item: `
                <div class="facet-item">
                    <a href="" class="facet-link toggle-refine facet-disjunctive">
                        <label>{{ label }}</label>
                    </a>
                </div><!-- /.facet-item -->
            `,
            },
            transformItems(items) {
                return normalizeFilterItems(items);
            },
        }),

        refinementList({
            container: '#facet-style',
            attribute: 'styles',
            limit: 100,
            sortBy: ['name:asc'],
            templates: {
                item: `
                <div class="facet-item">
                    <a href="" class="facet-link toggle-refine facet-disjunctive">
                        <label>{{ label }}</label>
                    </a>
                </div><!-- /.facet-item -->
            `,
            },
            transformItems(items) {
                return normalizeFilterItems(items);
            },
        }),
        
        refinementList({
            container: '#facet-coordinatingFinishes',
            attribute: 'coordinatingFinishes',
            limit: 100,
            sortBy: ['name:asc'],
            templates: {
                item: `
                <div class="facet-item">
                    <a href="" class="facet-link toggle-refine facet-disjunctive">
                        <label>{{ label }}</label>
                    </a>
                </div><!-- /.facet-item -->
            `,
            },
            transformItems(items) {
                return normalizeFilterItems(items);
            },
        }),

        /*refinementList({
            container: '#facet-durability',
            attribute: 'durability',
            limit: 100,
            sortBy: sortDura,
            templates: {
                item: `
                <div class="facet-item">
                    <a href="" class="facet-link toggle-refine facet-disjunctive">
                        <label>{{ label }} Cycles</label>
                    </a>
                </div><!-- /.facet-item -->
            `,
            },
            transformItems(items) {
                return normalizeFilterItems(items);
            },
        }),*/

        refinementList({
            container: '#facet-price',
            attribute: 'price_tier',
            limit: 100,
            sortBy: ['name:asc'],
            templates: {
                item(hit) {
                    let symbol = '(';
                    for (let i = 0; i < hit.label; i++) {
                        symbol += '$';
                    }
                    symbol += ')';
                    return `
                        <div class="facet-item">
                            <a href="" class="facet-link toggle-refine facet-disjunctive">
                                <label>${hit.label} ${symbol}</label>
                            </a>
                        </div><!-- /.facet-item -->
                    `;
                },
            },
            transformItems(items) {
                return normalizeFilterItems(items);
            },
        }),

        toggleRefinement({
            container: '#facet-new',
            attribute: 'new',
            on: 1,
            templates: {
                labelText: `New`,
            },
        }),
        
        toggleRefinement({
            container: '#facet-yard',
            attribute: 'yard',
            on: 1,
            templates: {
                labelText: `Available by the Yard`,
            },
        }),
    ]);

    search.start();

    search.helper.on('result', function(data) {
        if (data.nbHits < 36) {
            document.getElementById('pagination').style.display = 'none';
        } else {
            document.getElementById('pagination').style.display = 'block';
        }

        document.getElementById('facet-collection-header').style.display = 'none';
        //document.getElementById('facet-categories-header').style.display = 'none';
        document.getElementById('facet-color-header').style.display = 'none';
        document.getElementById('facet-featured-header').style.display = 'none';
        document.getElementById('facet-style-header').style.display = 'none';
        document.getElementById('facet-coordinatingFinishes-header').style.display = 'none';
        //document.getElementById('facet-durability-header').style.display = 'none';
        document.getElementById('facet-price-header').style.display = 'none';
        data.disjunctiveFacets.forEach(function(facet) {
            if (facet.name === 'collection') {
                document.getElementById('facet-collection-header').style.display = 'block';
            } else if (facet.name === 'categories') {
                //document.getElementById('facet-categories-header').style.display = 'block';
            } else if (facet.name === 'color') {
                document.getElementById('facet-color-header').style.display = 'block';
            } else if (facet.name === 'featured') {
                document.getElementById('facet-featured-header').style.display = 'block';
            } else if (facet.name === 'styles') {
                document.getElementById('facet-style-header').style.display = 'block';
            } else if (facet.name === 'coordinatingFinishes') {
                document.getElementById('facet-coordinatingFinishes-header').style.display = 'block';
            } else if (facet.name === 'durability') {
                //document.getElementById('facet-durability-header').style.display = 'block';
            } else if (facet.name === 'price_tier') {
                document.getElementById('facet-price-header').style.display = 'block';
            }
        });

        let showNew = false;

        /* eslint-disable-next-line */
        for (const key in search.helper.state.disjunctiveFacetsRefinements) {
            if (key === 'new') {
                document
                    .getElementById('facet-new')
                    .getElementsByTagName('span')[0]
                    .classList.add('active-facet');
                showNew = true;
            }
        }

        if (showNew === false) {
            document
                .getElementById('facet-new')
                .getElementsByTagName('span')[0]
                .classList.remove('active-facet');
        }
        
        let showYard = false;

        /* eslint-disable-next-line */
        for (const key in search.helper.state.disjunctiveFacetsRefinements) {
            if (key === 'yard') {
                document
                    .getElementById('facet-yard')
                    .getElementsByTagName('span')[0]
                    .classList.add('active-facet');
                showYard = true;
            }
        }

        if (showYard === false) {
            document
                .getElementById('facet-yard')
                .getElementsByTagName('span')[0]
                .classList.remove('active-facet');
        }
    });
}
